<template>
  <div class="player-tag-wrapper" v-if="player">
    <div class="control">
      <div
        class="tags has-addons"
        :class="{ 'is-hovered': focused }"
        ref="playerTag"
      >
        <span
          v-if="player.startingRank"
          class="tag"
          :class="player.hasNoLicense ? 'is-danger' : 'is-info'"
        >
          {{ player.startingRank }}
        </span>
        <a
          class="tag"
          :class="[tagStyle]"
          @mouseenter="showModal(700)"
          @mouseleave="stopModalOpen"
          @click="showModal(0)"
        >
          <span v-if="player.user.aiLevel">🤖</span>
          &nbsp;
          <span>{{ playerName || player.username }}</span>
        </a>
        <span v-if="player.scoreBeforeGame != null" class="tag is-warning">
          {{ player.scoreBeforeGame }}
        </span>
        <span v-else-if="player.score != null" class="tag is-link">
          {{ player.score }}
        </span>
        <a v-if="canClose" class="tag is-delete" @click="$emit('close')"></a>
      </div>
    </div>

    <!-- We're using the shared portal component registered in App.vue -->
  </div>
</template>

<script>
import { EventBus } from "@/services/event-bus";

export default {
  name: "PlayerTag",
  props: ["player", "totalRounds", "roundNumber", "canClose"],

  data() {
    return {
      focused: false,
      showTimeout: null,
      portalPosition: null,
    };
  },

  computed: {
    playerName() {
      return (
        (this.player.user.first_name || "") +
        " " +
        (this.player.user.last_name || "")
      ).trim();
    },

    tagStyle() {
      if (this.player.isParticipating) {
        return "is-success";
      }
      return "is-dark";
    },
  },

  methods: {
    showModal(ms = 300) {
      // Set focused state immediately for visual feedback
      this.focused = true;

      // Clear any existing timeout
      clearTimeout(this.showTimeout);

      // Calculate position for the portal
      this.calculatePortalPosition();

      // Only show the modal if the cursor stays for the specified time
      this.showTimeout = setTimeout(() => {
        // Only proceed if we're still focused (cursor hasn't left)
        if (this.focused) {
          // Show the shared portal with this player's data
          EventBus.$emit("show-player-portal", {
            player: this.player,
            totalRounds: this.totalRounds,
            roundNumber: this.roundNumber,
            position: this.portalPosition,
          });
        }
      }, ms);
    },

    calculatePortalPosition() {
      if (!this.$refs.playerTag) return;

      const rect = this.$refs.playerTag.getBoundingClientRect();
      this.portalPosition = {
        top: rect.top,
        left: rect.left,
      };
    },

    stopModalOpen() {
      this.focused = false;
      clearTimeout(this.showTimeout);
    },
  },

  beforeDestroy() {
    // Clean up timeouts
    clearTimeout(this.showTimeout);
  },
};
</script>

<style scoped>
.player-tag-wrapper {
  display: inline-block;
  margin: 0.5rem;
  position: relative;
}

.tags.is-hovered .tag {
  box-shadow: 0 0 0 2px rgba(50, 115, 220, 0.25);
  transform: translateY(-1px);
}

.tag {
  cursor: pointer;
  transition: all 0.2s ease;
}
</style>
